(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["birthstone-zodiac"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var navItem = event.target.closest('[data-birthstone-nav-item]');
    if (!navItem) return;

    var root = navItem.closest('[data-birthstone-zodiac]');
    if (!root) return;

    var index = navItem.dataset.index;

    root.querySelectorAll('[data-birthstone-nav-item]').forEach(function (item) {
      var isActive = item.dataset.index === index;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    root.querySelectorAll('[data-birthstone-slide]').forEach(function (slide) {
      slide.classList.toggle('is-active', slide.dataset.slideIndex === index);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var control = event.target.closest('[data-cart-qty-increase], [data-cart-qty-decrease]');
    if (!control) return;

    var wrapper = control.closest('.cart-page__item-qty');
    var input = wrapper.querySelector('.cart-page__qty-input');
    var value = parseInt(input.value, 10) || 0;

    value = control.hasAttribute('data-cart-qty-increase') ? value + 1 : Math.max(0, value - 1);
    input.value = value;
    input.form.requestSubmit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customers-addresses"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var editOpen = event.target.closest('[data-address-edit-open]');
    var editClose = event.target.closest('[data-address-edit-close]');
    var addOpen = event.target.closest('[data-address-add-open]');
    var addClose = event.target.closest('[data-address-add-close]');
    var deleteBtn = event.target.closest('[data-address-delete]');

    if (editOpen) {
      var id = editOpen.getAttribute('data-address-edit-open');
      var view = document.querySelector('[data-address-view="' + id + '"]');
      var edit = document.querySelector('[data-address-edit="' + id + '"]');
      if (view) view.hidden = true;
      if (edit) edit.hidden = false;
      return;
    }

    if (editClose) {
      var closeId = editClose.getAttribute('data-address-edit-close');
      var closeView = document.querySelector('[data-address-view="' + closeId + '"]');
      var closeEdit = document.querySelector('[data-address-edit="' + closeId + '"]');
      if (closeView) closeView.hidden = false;
      if (closeEdit) closeEdit.hidden = true;
      return;
    }

    if (addOpen) {
      var addForm = document.querySelector('[data-address-add-form]');
      if (addForm) {
        addForm.hidden = false;
        addOpen.hidden = true;
      }
      return;
    }

    if (addClose) {
      var closeAddForm = document.querySelector('[data-address-add-form]');
      var addToggle = document.querySelector('[data-address-add-open]');
      if (closeAddForm) closeAddForm.hidden = true;
      if (addToggle) addToggle.hidden = false;
      return;
    }

    if (deleteBtn) {
      var confirmMessage = deleteBtn.getAttribute('data-confirm');
      if (window.confirm(confirmMessage)) {
        var deleteId = deleteBtn.getAttribute('data-address-delete');
        var deleteForm = document.getElementById('address_delete_' + deleteId);
        if (deleteForm) deleteForm.submit();
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customers-login"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var card = event.target.closest('[data-login-card]');
    if (!card) return;

    var openLink = event.target.closest('[data-recover-open]');
    var closeLink = event.target.closest('[data-recover-close]');
    if (!openLink && !closeLink) return;

    event.preventDefault();

    var loginPanel = card.querySelector('[data-login-panel]');
    var recoverPanel = card.querySelector('[data-recover-panel]');

    if (openLink) {
      loginPanel.hidden = true;
      recoverPanel.hidden = false;
      var emailField = recoverPanel.querySelector('input[type="email"]');
      if (emailField) emailField.focus();
    } else {
      recoverPanel.hidden = true;
      loginPanel.hidden = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-nav-drawer-open]');
    if (openTrigger) {
      var dialog = document.getElementById(openTrigger.getAttribute('aria-controls'));
      if (dialog) dialog.showModal();
      return;
    }

    var closeTrigger = event.target.closest('[data-nav-drawer-close]');
    if (closeTrigger) {
      var dialog = closeTrigger.closest('dialog');
      if (dialog) dialog.close();
      return;
    }

    if (event.target.tagName === 'DIALOG' && event.target.classList.contains('nav-drawer')) {
      var rect = event.target.getBoundingClientRect();
      var inside =
        rect.top <= event.clientY &&
        event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX &&
        event.clientX <= rect.left + rect.width;
      if (!inside) event.target.close();
    }
  });

  (function () {
    var announcementBar = document.querySelector('.announcement-bar');
    var header = document.querySelector('.site-header');
    if (!header) return;

    function setOffsets() {
      var headerHeight = header.getBoundingClientRect().height;
      var announcementHeight = announcementBar ? announcementBar.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--sticky-header-height', headerHeight + 'px');
      document.documentElement.style.setProperty('--announcement-bar-height', announcementHeight + 'px');
      document.documentElement.style.setProperty('--top-bar-height', headerHeight + announcementHeight + 'px');
    }

    setOffsets();
    window.addEventListener('resize', setOffsets);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(setOffsets);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var stat = document.querySelector('.hero__stat-number');
    if (!stat) return;

    var raw = stat.getAttribute('data-count-target') || stat.textContent;
    var match = raw.match(/^(\d+)(.*)$/);
    if (!match) return;

    var target = parseInt(match[1], 10);
    var suffix = match[2] || '';
    if (!target || target <= 1) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var animated = false;
    function animate() {
      if (animated) return;
      animated = true;

      var duration = 1200;
      var start = null;

      function step(timestamp) {
        if (start === null) start = timestamp;
        var progress = Math.min((timestamp - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var current = Math.round(1 + eased * (target - 1));
        stat.textContent = current + suffix;
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          stat.textContent = target + suffix;
        }
      }

      requestAnimationFrame(step);
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animate();
            observer.disconnect();
          }
        });
      },
      { threshold: 0.4 }
    );
    observer.observe(stat);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-feed"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-quickview-open]');
    if (openTrigger) {
      var item = openTrigger.closest('[data-quickview-item]');
      var dialog = item && item.querySelector('[data-quickview-dialog]');
      if (dialog && typeof dialog.showModal === 'function') {
        document.querySelectorAll('[data-quickview-dialog][open]').forEach(function (open) {
          open.close();
        });
        dialog.showModal();
      }
      return;
    }

    var closeTrigger = event.target.closest('[data-quickview-close]');
    if (closeTrigger) {
      var dialog = closeTrigger.closest('[data-quickview-dialog]');
      if (dialog) dialog.close();
      return;
    }

    var backdropDialog = event.target.closest('[data-quickview-dialog]');
    if (backdropDialog && event.target === backdropDialog) {
      backdropDialog.close();
    }
  });

  document.querySelectorAll('[data-instagram-scroller]').forEach(function (scroller) {
    var track = scroller.querySelector('[data-instagram-track]');
    if (!track) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var pointerDown = false;
    var dragged = false;
    var startX = 0;
    var startScroll = 0;
    var speed = 0.6;

    function halfWidth() {
      return track.scrollWidth / 2;
    }

    function autoAdvance() {
      if (!pointerDown && !reducedMotion) {
        var half = halfWidth();
        if (half > 0) {
          scroller.scrollLeft += speed;
          if (scroller.scrollLeft >= half) {
            scroller.scrollLeft -= half;
          }
        }
      }
      window.requestAnimationFrame(autoAdvance);
    }

    scroller.addEventListener('pointerdown', function (event) {
      pointerDown = true;
      dragged = false;
      startX = event.clientX;
      startScroll = scroller.scrollLeft;
      scroller.setPointerCapture(event.pointerId);
    });

    scroller.addEventListener('pointermove', function (event) {
      if (!pointerDown) return;
      var delta = event.clientX - startX;
      if (Math.abs(delta) > 3) {
        dragged = true;
        scroller.classList.add('is-dragging');
      }
      scroller.scrollLeft = startScroll - delta;
    });

    function endDrag(event) {
      pointerDown = false;
      scroller.classList.remove('is-dragging');
      if (event && scroller.hasPointerCapture(event.pointerId)) {
        scroller.releasePointerCapture(event.pointerId);
      }
    }

    scroller.addEventListener('pointerup', endDrag);
    scroller.addEventListener('pointercancel', endDrag);

    scroller.addEventListener(
      'click',
      function (event) {
        if (dragged) {
          event.preventDefault();
          event.stopPropagation();
          dragged = false;
        }
      },
      true
    );

    window.requestAnimationFrame(autoAdvance);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-product-qty-decrease], [data-product-qty-increase]');
    if (!btn) return;

    var stepper = btn.closest('.product__qty-stepper');
    var input = stepper.querySelector('.product__qty-input');
    var value = parseInt(input.value, 10) || 1;

    if (btn.hasAttribute('data-product-qty-increase')) {
      value += 1;
    } else {
      value = Math.max(1, value - 1);
    }

    input.value = value;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var control = event.target.closest('[data-testimonials-prev], [data-testimonials-next]');
    if (!control) return;

    var wrapper = control.closest('[data-testimonials]');
    if (!wrapper) return;

    var slides = Array.from(wrapper.querySelectorAll('.testimonials__slide'));
    var currentIndex = slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    });

    var direction = control.hasAttribute('data-testimonials-next') ? 1 : -1;
    var nextIndex = (currentIndex + direction + slides.length) % slides.length;

    slides[currentIndex].classList.remove('is-active');
    slides[nextIndex].classList.add('is-active');
  });

  } catch(e) { console.error(e); }
})();
})();
